import React  from 'react';

import RAGComponentProto from './rag-proto';

export default function renderBooleanInEdit(id, props) {
    return <RAGComponentProto renderMode="edit" id={id} {...props} />;
}